import styled from "styled-components";
import { BLUE, MIN_INFO_WIDTH } from "@root/common";

const MobileInfoScroll = styled.div`
    @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
        width: 100%;
        flex-shrink: 0;
        overflow: visible;
        padding-top: 96px;
        padding-bottom: 16px;
        box-sizing: border-box;
    }
`

const UpperInfoStyled = styled.div`
    position: relative;
    height: 50%;
    width: 100%;
    padding: 2.5%;
    padding-top: 0;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 12px;

    @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
        height: auto;
        flex-shrink: 0;
        padding-top: 0;
    }
`

const TitlesContainer = styled.div`
    height: calc(100% / 2);
    position: relative;
    width: 100%;
    margin-top: 2em;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: start;
    gap: 0 10%;

    @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
        height: auto;
        margin-top: 0;
    }
`

const InfoSettings = styled.div`
  width: 45%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 8px;

  @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
    justify-content: flex-start;
  }

  p {
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;

    input {
        width: calc(100% - 6em);
        border-radius: 8px;
        outline: none;

        margin-left: 1em;
        padding: 6px;

        &:focus {
            border: 1px solid black;
        }

        appearance: none;
        margin: 0;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* for firefox */
    input[type=number]{
      -moz-appearance: textfield;
    }
  }
`

const Info = styled.div`
  height: calc(100% * 2 / 3);

  padding: 1em;
  padding-right: 1em;
  padding-bottom: 4em;
  border: 1px solid;
  border-radius: 1em;
  width: fit-content;
  min-width: calc(45% * 2 / 3);

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  p {
    white-space: nowrap;
  }

  @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
    height: auto;
    padding-bottom: 1em;
  }
`

const LongShortContainer = styled.div`
    height: calc(100% / 2);
    width: 100%;

    display: flex;
    flex-direction: row;
    gap: 0 10%;
    flex-wrap: wrap;

    @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
        height: auto;
    }

    div {
        width: 45%;
        height: 100%;
        padding: 5px 1em;
        border: 1px solid black;
        border-radius: 1em;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        @media (max-width: calc(2 * ${MIN_INFO_WIDTH})) {
            height: auto;
        }

        a {
            color: ${BLUE};
            text-decoration: none;
            font-size: 1.2em;
        }

        p {
            width: 100%;
            text-align: start;
        }
    }
`

export {UpperInfoStyled, TitlesContainer, LongShortContainer, InfoSettings, Info, MobileInfoScroll}
